// components
import { CompactPlaylist } from '../../compactPlaylist/CompactPlaylist'
import { PlaylistPanel } from '../../playlistPanel/PlaylistPanel'

interface Props {
    playlistName: string | null
}

export const MobilePortraitView = ({playlistName}: Props) => {
    return (
        <>
            {/* Compact Playlist */}
            <CompactPlaylist mobileView={true} playlistName={playlistName} />

            {/* Playlist section */}
            <PlaylistPanel view='listMobile' playlistName={playlistName} />
        </>
    )
}
